var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echartsMapAllDemo"},[_c('div',{ref:"myEcharts",staticStyle:{"width":"133%","height":"118%","position":"absolute","left":"-15px","top":"-120px"},attrs:{"id":"myEcharts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }